export const createQtLoader = (canvas, modulePath, callbacks = {}) => {
    const {
        onShowLoader = () => {},
        onShowError = () => {},
        onShowExit = () => {},
        onShowCanvas = () => {}
    } = callbacks;

    const qtLoader = QtLoader({
        canvasElements: [canvas],
        showLoader: () => {
            canvas.style.display = 'none';
            onShowLoader();
        },
        showError: () => {
            canvas.style.display = 'none';
            onShowError();
        },
        showExit: () => {
            canvas.style.display = 'none';
            onShowExit();
        },
        showCanvas: () => {
            canvas.style.display = 'block';
            onShowCanvas();
        },
    });
    qtLoader.loadEmscriptenModule(modulePath);
    return qtLoader;
};
